(function () {
  'use strict';

  function initVSAboutStory(root) {
    const sections = root
      ? [root]
      : document.querySelectorAll('[data-vs-about-story]');

    sections.forEach(function (section) {

      if (!section || section.dataset.vsStoryReady === 'true') {
        return;
      }

      section.dataset.vsStoryReady = 'true';

      const image = section.querySelector(
        '.vs-about-story__image'
      );

      if (image) {

        if (image.complete) {
          section.classList.add(
            'vs-about-story--image-loaded'
          );
        }

        image.addEventListener(
          'load',
          function () {
            section.classList.add(
              'vs-about-story--image-loaded'
            );
          }
        );

      }


      /*
       * Subtle hover zoom.
       * Disabled automatically on touch devices.
       */

      if (
        window.matchMedia &&
        !window.matchMedia(
          '(hover: none)'
        ).matches
      ) {

        const media =
          section.querySelector(
            '.vs-about-story__media'
          );

        if (media && image) {

          media.addEventListener(
            'mouseenter',
            function () {
              image.style.transform =
                'translate(-50%, -50%) scale(calc(var(--vs-story-image-scale) + 0.025))';
            }
          );

          media.addEventListener(
            'mouseleave',
            function () {
              image.style.transform =
                'translate(-50%, -50%) scale(var(--vs-story-image-scale))';
            }
          );

        }

      }

    });
  }


  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initVSAboutStory();
    }
  );


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '[data-vs-about-story]'
        );

      if (section) {
        initVSAboutStory(section);
      }

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      const block =
        event.target.closest(
          '[data-vs-about-story]'
        );

      if (block) {
        initVSAboutStory(block);
      }

    }
  );

})();